import {
  withStyles,
} from '@material-ui/core/styles';
import { Checkbox } from '@material-ui/core';
const CssCheckbox = withStyles({

})(Checkbox);

export default CssCheckbox;